import getEnvironment, { getEnvItem } from './getEnvironment';

const env = getEnvironment();

class YupUpConfig {

  get apiUrl(){
    return getEnvItem('API_URL');
  }
  get wsUrl(){
    return getEnvItem('WS_URL');
  }

}

let yupupConfig = new YupUpConfig();
export default yupupConfig;
